import {
  Box,
  Button,
  Grid,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import { IValidationParms } from "../../utility/interfaces/common/validation-parms";
import { IFamilyFriendDetails } from "../../utility/interfaces/create-request/create-request-details";
import PatientDetails from "./patient-details";
import { CreateRequestType } from "../../utility/enums/create-request";
import { WarningModal } from "../common/warning-modal";
import { useContext, useEffect, useState } from "react";
import { PhoneTypeModal } from "../common/phonetype-modal";
import { IRegions } from "../../utility/interfaces";
import createRequestService from "../../services/create-request-service";
import {
  createCommonAPICall,
  hideLoader,
  openSucessErrorModal,
} from "../../utility/helpers";
import { SuccessErrorModalDispatchContext } from "../../contexts/success-error-context";
import Geocode from "react-geocode";
import { useNavigate } from "react-router-dom";
import { AppRoutings } from "../../utility/enums/app-routings";
import CustomIntlTelInput from "../common/custom-intl-tel-input";
import dashboardService from "../../services/dashboard-service";
import { Constants } from "utility/enums/constants";
import { OptInCheckBox } from "components";

type ComponentProps = {
  details: IFamilyFriendDetails;
  onChangeDetails: any;
  validationParams: IValidationParms;
  handleOnBackButtonClick: any;
};

export const FamilyOrFriendForm = (props: ComponentProps) => {
  // page level variables
  const navigate = useNavigate();

  // use context
  const setSuccessErrorContext = useContext(SuccessErrorModalDispatchContext);
  Geocode.setApiKey(Constants.GeocodeKey);

  // Extract Props
  const {
    details,
    onChangeDetails,
    validationParams,
    handleOnBackButtonClick,
  } = props;

  // use state
  const [warningModalOpen, setWarningModalOpen] = useState(false);
  const [wrongContactInfoModalOpen, setWrongContactInfoModalOpen] =
    useState(false);
  const [phoneTypeModelOpen, setphoneTypeModelOpen] = useState(false);
  const [responsibleParty, setResponsibleParty] = useState("P");
  const [stateResponse, setStateResponse] = useState<IRegions[]>([]);
  const [txtstate, setTxtState] = useState<string[]>([]);
  const [requestGuid, setRequestGuid] = useState("");
  const [fileName, setFileName] = useState("");
  const [isPhoneNumberValid, setIsPhoneNumberValid] = useState(true);
  const [isRequestorPhoneNumberValid, setIsRequestorPhoneNumberValid] =
    useState(true);

  // Handled event(s)
  const getRegions = async () => {
    const data = await createCommonAPICall({
      apiService: createRequestService.getRegions,
      showSuccessMessage: false,
      showErrorMessage: true,
      setSuccessErrorContext,
    });
    if (data && data.data) {
      for (let i = 0; i < data.data.length; i++) {
        txtstate.push(data.data[i].name);
      }
      setStateResponse(data.data);
    }
  };

  const handlePhoneTypeModelOpen = () => setphoneTypeModelOpen(true);

  const handlePhoneTypeModelClose = () => setphoneTypeModelOpen(false);

  const onRadioChange = (event: any) => {
    onChangeDetails("radioRequestorPhoneType", event);
  };

  const onChangePatientDetails = (name: string, value: any) => {
    const patientTempDetails = { ...details.patientDetails, [name]: value };
    onChangeDetails("patientDetails", patientTempDetails);
  };

  const onSelectResponsibleParty = (event: any) => {
    setResponsibleParty(event);
  };

  const handleWarningModalClose = () => {
    setWarningModalOpen(false);
  };

  const handleWrongContactInfoModalClose = () => {
    setWrongContactInfoModalOpen(false);
  };

  const handleOnClickSubmit = () => {
    if (validateResponsibleParty()) {
      var address =
        details.patientDetails.street +
        " " +
        details.patientDetails.city +
        ", " +
        details.patientDetails.state +
        " " +
        details.patientDetails.zipCode;

      if (
        new Date(details.patientDetails.birthDate!).toLocaleString("en-US") !==
        "Invalid Date"
      ) {
        Geocode.fromAddress(address).then(
          async (response) => {
            const { lat, lng } = response.results[0].geometry.location;
            var isValid = await CheckValidRegion(response.results[0]);
            if (isValid) {
              const requestBody = {
                requestTypeId: CreateRequestType.familyOrFriend,
                requestorFirstName: details.friendFirstName,
                requestorLastName: details.friendLastName,
                requestorPhoneNumber: details.friendPhoneNumber,
                requestorEmail: details.friendEmail,
                relationWithPatient: details.relationWithPatient,
                clientNotes: details.patientDetails.symptoms,
                firstName: details.patientDetails.firstName,
                lastName: details.patientDetails.lastName,
                // dateOfBirth: new Date(details.patientDetails.birthDate),
                dateOfBirth: new Date(details.patientDetails.birthDate),
                strDateOfBirth: new Date(
                  details.patientDetails.birthDate!
                ).toLocaleString("en-US"),
                phoneNumber: details.patientDetails.phoneNumber,
                email: details.patientDetails.email,
                street: details.patientDetails.street,
                city: details.patientDetails.city,
                state: details.patientDetails.state,
                zipCode: details.patientDetails.zipCode,
                room: details.patientDetails.room,
                radioClientPhoneType:
                  details.patientDetails.radioClientPhoneType,
                radioRequestorPhoneType: details.radioRequestorPhoneType,
                clientRegionId: details.patientDetails.clientRegionId,
                requestGuid: requestGuid,
                fileName: fileName,
                isPatientSMSOpted: details.patientDetails.isPatientSMSOpted,
                isRequestorSMSOpted: details.isRequestorSMSOpted,
              };

              const data = await createCommonAPICall({
                requestBody,
                apiService: createRequestService.createOtherTypeRequest,
                showErrorMessage: true,
                showSuccessMessage: false,
                setSuccessErrorContext,
              });

              if (data && data.isSuccessfull) {
                navigate(AppRoutings.RequestSuccess, {
                  state: {
                    message: data.message,
                    requestTypeId: requestBody.requestTypeId,
                  },
                });
              }
            } else {
              hideLoader();
              openSucessErrorModal(
                setSuccessErrorContext,
                "Error",
                "At this time, we are only able to service select areas in DC, Maryland, Virginia, and New York City.",
                false
              );
            }
          },
          (error) => {
            openSucessErrorModal(
              setSuccessErrorContext,
              "Error",
              "At this time, we are only able to service select areas in DC, Maryland, Virginia, and New York City.",
              false
            );
          }
        );
      } else {
        hideLoader();
        openSucessErrorModal(
          setSuccessErrorContext,
          "Error",
          "Please enter a valid birthdate (MM/DD/YYYY)",
          false
        );
      }
    } else {
      if (details.friendPhoneNumber == details.patientDetails.phoneNumber) {
        setIsPhoneNumberValid(false);
        setIsRequestorPhoneNumberValid(false);
      }

      if (details.friendEmail == details.patientDetails.email) {
        validationParams.setError("friendEmail", {
          type: "manual",
          message: "Enter different email than patient email",
        });
        validationParams.setError("email", {
          type: "manual",
          message: "Enter different email than your email",
        });
      }
      setWrongContactInfoModalOpen(true);
    }
  };

  const CheckValidRegion = async (places: any) => {
    // get state from address
    var isValidState = false;
    var stateName;
    for (var component in places["address_components"]) {
      for (var i in places["address_components"][component]["types"]) {
        if (
          places["address_components"][component]["types"][i] ==
          "administrative_area_level_1"
        ) {
          stateName = places["address_components"][component]["long_name"];
          for (var j = 0; j < txtstate.length; j++) {
            if (stateName == txtstate[j]) {
              isValidState = true;
              for (let s = 0; s < stateResponse.length; s++) {
                if (stateResponse[s].name == stateName) {
                  details.patientDetails.clientRegionId =
                    stateResponse[s].regionId;
                }
              }
            }
          }
        }
      }
    }
    if (isValidState && isValidState == true) {
      const zipCodesRes = await createCommonAPICall({
        apiService: dashboardService.getAllZipCodes,
        showErrorMessage: true,
        showSuccessMessage: false,
        setSuccessErrorContext,
      });

      if (zipCodesRes && zipCodesRes.isSuccessfull) {
        if (
          !zipCodesRes.data.some(
            (zip: any) => zip.zipCode == details.patientDetails.zipCode
          )
        ) {
          return false;
        } else {
          return true;
        }
      }
      return false;
    } else {
      console.log(
        "At this time, we" +
          "'" +
          "re only able to service select areas in DC, Maryland, Virginia, and New York City."
      );
    }
  };

  const validateResponsibleParty = () => {
    if (
      (details.friendEmail == details.patientDetails.email ||
        details.friendPhoneNumber == details.patientDetails.phoneNumber) &&
      responsibleParty == "P"
    ) {
      return false;
    }
    return true;
  };

  const handlePhoneNumberChange = (
    isValid: any,
    phoneNumber: any,
    countryData: any
  ) => {
    setIsRequestorPhoneNumberValid(isValid);
    let formattedPhoneNumber =
      phoneNumber != ""
        ? phoneNumber.includes("+")
          ? phoneNumber
          : `+${countryData.dialCode} ${phoneNumber}`
        : "";
    onChangeDetails("friendPhoneNumber", formattedPhoneNumber);
  };

  useEffect(() => {
    setWarningModalOpen(true);
    getRegions();
  }, []);

  return (
    <>
      <Box>
        <Box className="request-box">
          <Typography variant="h4">Family/Friend Information</Typography>
          <div>
            <Grid container columnSpacing={{ sm: 2, lg: 3 }}>
              <Grid item xs={12} sm={6}>
                <TextField
                  autoFocus
                  {...validationParams?.register("friendFirstName")}
                  error={
                    validationParams?.errors?.friendFirstName?.message
                      ? true
                      : false
                  }
                  helperText={validationParams?.errors?.friendFirstName?.message?.toString()}
                  name="friendFirstName"
                  id="friendFirstName"
                  label="Your First Name"
                  value={details.friendFirstName}
                  fullWidth
                  onChange={(e) =>
                    onChangeDetails(e.target.name, e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  {...validationParams?.register("friendLastName")}
                  error={
                    validationParams?.errors?.friendLastName?.message
                      ? true
                      : false
                  }
                  helperText={validationParams?.errors?.friendLastName?.message?.toString()}
                  name="friendLastName"
                  id="friendLastName"
                  label="Your Last Name"
                  value={details.friendLastName}
                  fullWidth
                  onChange={(e) =>
                    onChangeDetails(e.target.name, e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <CustomIntlTelInput
                  isPhoneNumberValid={isRequestorPhoneNumberValid}
                  onChange={handlePhoneNumberChange}
                  onBlur={() => {
                    if (details.friendPhoneNumber !== "")
                      handlePhoneTypeModelOpen();
                  }}
                  value={details.friendPhoneNumber}
                  name="friendPhoneNumber"
                />
                {/* <IntlTelInput
                  {...validationParams?.register("phoneNumber")}
                  defaultCountry="us"
                  containerClassName="intl-tel-input intl-tel-container-custom"
                  preferredCountries={["us"]}
                  inputClassName={`intl-tel-input-custom ${
                    !isRequestorPhoneNumberValid ? "invalid" : ""
                  }`}
                  onPhoneNumberChange={handlePhoneNumberChange}
                  allowDropdown={true}
                  format={true}
                />
                <FormHelperText error id="component-error-text">
                  <>
                    {!isRequestorPhoneNumberValid
                      ? details.friendPhoneNumber != ""
                        ? "Enter valid phone number"
                        : "Phone number is required"
                      : ""}
                  </>
                </FormHelperText> */}
                {/* <TextField
                  {...validationParams?.register("friendPhoneNumber")}
                  error={
                    validationParams?.errors?.friendPhoneNumber?.message
                      ? true
                      : false
                  }
                  helperText={validationParams?.errors?.friendPhoneNumber?.message?.toString()}
                  name="friendPhoneNumber"
                  id="friendPhoneNumber"
                  label="Your Phone Number"
                  value={details.friendPhoneNumber}
                  fullWidth
                  onChange={(e) =>
                    onChangeDetails(e.target.name, e.target.value)
                  }
                  onBlurCapture={handlePhoneTypeModelOpen}
                /> */}
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  {...validationParams?.register("friendEmail")}
                  error={
                    validationParams?.errors?.friendEmail?.message
                      ? true
                      : false
                  }
                  helperText={validationParams?.errors?.friendEmail?.message?.toString()}
                  name="friendEmail"
                  id="friendEmail"
                  label="Your Email"
                  value={details.friendEmail}
                  fullWidth
                  onChange={(e) =>
                    onChangeDetails(e.target.name, e.target.value)
                  }
                />
              </Grid>
              <Grid item xs={12}>
                <OptInCheckBox
                  isSmsOpted={details.isRequestorSMSOpted}
                  onChange={() =>
                    onChangeDetails(
                      "isRequestorSMSOpted",
                      !details.isRequestorSMSOpted
                    )
                  }
                />
              </Grid>
              <Grid item xs={12} sm={6}>
                <TextField
                  name="relationWithPatient"
                  id="relationWithPatient"
                  label="Relation With Patient"
                  value={details.relationWithPatient}
                  fullWidth
                  onChange={(e) =>
                    onChangeDetails(e.target.name, e.target.value)
                  }
                />
              </Grid>
            </Grid>
          </div>
          <PatientDetails
            validationParams={validationParams}
            patientDetails={details.patientDetails}
            onChangePatientDetails={onChangePatientDetails}
            requestTypeId={CreateRequestType.familyOrFriend}
            onSelectResponsibleParty={onSelectResponsibleParty}
            setFileName={setFileName}
            setRequestGuid={setRequestGuid}
            isPhoneNumberValid={isPhoneNumberValid}
            setIsPhoneNumberValid={setIsPhoneNumberValid}
          />
          <div className="request-btn-group">
            <Tooltip title="Click Here To Submit">
              <Button
                onClick={() => {
                  if (
                    details.patientDetails.phoneNumber === "" ||
                    details.friendPhoneNumber === "" ||
                    !isPhoneNumberValid ||
                    !isRequestorPhoneNumberValid
                  ) {
                    if (details.patientDetails.phoneNumber === "")
                      setIsPhoneNumberValid(false);
                    if (details.friendPhoneNumber === "")
                      setIsRequestorPhoneNumberValid(false);
                    validationParams.handleSubmit(() =>
                      console.log("phone number required")
                    )();
                  } else {
                    validationParams.handleSubmit(handleOnClickSubmit, () => {
                      console.log("Form values: ", details);
                    })();
                  }
                }}
                variant="contained"
              >
                Submit
              </Button>
            </Tooltip>
            <Tooltip title="Click Here To Cancel">
              <Button onClick={handleOnBackButtonClick} variant="outlined">
                Cancel
              </Button>
            </Tooltip>
          </div>
        </Box>
      </Box>
      <WarningModal
        isModalOpen={warningModalOpen}
        handleOnClickCloseModal={handleWarningModalClose}
        handleOnClickOk={() => {}}
        warningMessage={
          "When submitting a request, you must provide the correct contact information for the patient or the responsibly party. Failure to provide the correct email and phone number will delay service or be declined."
        }
        title={"Information"}
        okButtonText={"Ok"}
        closeButtonText={undefined}
      />
      <WarningModal
        isModalOpen={wrongContactInfoModalOpen}
        handleOnClickCloseModal={handleWrongContactInfoModalClose}
        handleOnClickOk={() => {}}
        warningMessage={
          "When submitting a request on behalf of someone else (family, friend, or business), the responsible party must enter a phone number and email that are different from the patient's. Please update your contact details and try again."
        }
        title={"Contact Information Conflict"}
        okButtonText={"Ok"}
        closeButtonText={undefined}
      />
      <PhoneTypeModal
        phoneTypeModelOpen={phoneTypeModelOpen}
        handlePhoneTypeModelClose={handlePhoneTypeModelClose}
        onSelectPhoneType={onRadioChange}
      ></PhoneTypeModal>
    </>
  );
};
